// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"310":"bed9e99c","423":"741d21f0","626":"bdedb85a","732":"930be875","767":"81fd1c7b","829":"f364fd82","835":"28c2218c","911":"c058e7ba","992":"6b2d210c"}[chunkId] + ".chunk.js";
};